var React = require('react');

function GoodLatency (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18 4C17.4477 4 17 4.44772 17 5V19C17 19.5523 17.4477 20 18 20H20C20.5523 20 21 19.5523 21 19V5C21 4.44772 20.5523 4 20 4H18Z","fill":"#1BE3AD","key":0}),React.createElement("path",{"d":"M10 11C10 10.4477 10.4477 10 11 10H13C13.5523 10 14 10.4477 14 11V19C14 19.5523 13.5523 20 13 20H11C10.4477 20 10 19.5523 10 19V11Z","fill":"#1BE3AD","key":1}),React.createElement("path",{"d":"M3 15C3 14.4477 3.44772 14 4 14H6C6.55228 14 7 14.4477 7 15V19C7 19.5523 6.55228 20 6 20H4C3.44772 20 3 19.5523 3 19V15Z","fill":"#1BE3AD","key":2})]);
}

GoodLatency.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = GoodLatency;

GoodLatency.default = GoodLatency;
